export default {
    label: {
        versao: "19.3.4.7 2026-03-18 17:00",
        abertura: "Abertura",
        analista: "Analista",
        login: "Login",
        nome: "Nome",
        nomeSocial: "Nome Social",
        razaoSocial: "Razão Social",
        nomeRazao: "Nome/Razão Social",
        cpf: "CPF",
        cnpj: "CNPJ",
        registro: "Registro",
        cpfCnpj: "CPF/CNPJ",
        cpfOuCnpj: "CPF ou CNPJ",
        rg: "RG",
        passaporte: "Número do Passaporte",
        pessoaFisica: "Pessoa Física",
        pessoaJurica: "Pessoa Jurídica",
        cep: "CEP",
        senha: "Senha",
        repitaSenha:"Repita Senha",
        inss: "INSS",
        dataSolicitacao: "Data Solicitação",
        fgts: "FGTS",
        sefaz: "Sefaz",
        seFazBa: "Sefaz-Ba",
        statusSolicitacao: "Status Solicitação",
        arquivo: "Arquivo",
        familia: "Família",
        cgc: "CGC",
        crc: "CRC",
        crs: "CRS",
        crcCrs: "CRC/CRS",
        situacaoCadastral: "Situação Cadastral",
        re: "RE",
        credenciamento: "Credenciamento",
        candidato: "Candidato",
        codCredorFiplan:"Código Credor (FIPLAN)",
        fornecedor: "Fornecedor",
        assinaturaDigital: "Assinatura Digital",
        dadosFornecedor: "Dados Fornecedor",
        contato: "Contato",
        nomeFantasia: "Nome Fantasia",
        endereco: "Endereço",
        upload: "Upload",
        logradouro: "Logradouro",
        numero: "Número",
        complemento: "Complemento",
        bairro: "Bairro",
        cidade: "Cidade",
        email: "E-mail",
        confirmeEmail: "Confirme o E-mail", // Nova label adicionada de E-mail
        celular: "Celular", // Nova label para o campo celular
        emailAdicional: "E-mail Adicional",
        extrato: "Extrato",
        termoConcordancia:"Termo de Concordância e Veracidade",
        fornecedorTipo: "Fornecedor Tipo",
        tipo: "Tipo",
        nacionalidade: "Nacionalidade",
        fornecedorNacionalidade: "Fornecedor Nacionalidade",
        uf: "UF",
        pais: "Pais",
        estado: "Estado",
        telefone: "Telefone",
        fax: "Fax",
        telefoneAdicional:"Telefone Adicional",
        categoria: "Categoria",
        brasileiro: "Brasileiro",
        estrangeiro: "Estrangeiro",
        certificado: "Certificado",
        certificadoTipo: "Certificado Tipo",
        nomeContato: "Nome Contato",
        voltar: "Voltar",
        continuar: "Continuar",
        informacaoDeAcesso: "Informação de Acesso",
        percentual: "Percentual",
        dirigentes: "Dirigentes",
        dirigente: "Dirigente",
        socios:"Sócios",
        socio: "Sócio",
        cargo: "Cargo",
        dataContratoSocial:"Data do Contrato",
        dataExpedicao:"Data de Expedição",
        anexarDocumentos:"Anexar Documentos",
        anexoDoDocumentosRGCPFCNHOutros:"Anexar Documentos (RG, CPF, CNH ou Outros)",
        anexoDocumentoIdentificacaoEstrangeiro: "Anexar Documentos (Passaporte com Tradução Juramentada)",
        anexaDocumento:"Anexar Documento",
        anexarDocumentoIdentidade:"Anexo do Documento",
        nomeDocumento:"Nome do documento",
        anexarContratoSocial:"Anexar Contrato",
        orgaoEmissor:"Órgão Emissor",
        anexo:"Anexo",
        acoes:"Ações",
        anexoContratoSocial:"Anexo do Contrato Social",
        grupo:"Grupo",
        ramoAtividade:"Ramo de Atividade",
        tipoDoItem:"Tipo do Item",
        tipoDeQualificacao:"Tipo de Qualificação",
        cadastro: "Cadastro",
        numeroDocumento:"Nº Documento",
        dataEmissao:"Data de Emissão",
        dataValidade:"Data de Validade",
        situacao:"Situação",
        codDeControle:"Cód. Controle",
        situacaoSolicitacao:"Situação Solicitação",
        tipoSolicitacao:"Tipo Solicitação",
        dataInicio:"Data Inicial",
        dataFinal:"Data Final",
        numLivroDiario: "Nº Livro Diário",
        ativoCirculante:"Ativo Circulante",
        ativo:"Ativo",
        outrosIndices:"Outros Índices",
        ativoNaoCirculante:"Ativo Não Circulante",
        concordataEFalencia: "Concordata e Falência",
        realizavelALongoPrazo:"Realizável a Longo Prazo",
        investimento:"Investimento",
        imobilizado:"Imobilizado",
        intangivel:"Intangível",
        ativoTotal:"Ativo Total",
        passivo:"Passivo",
        passivoCirculante:"Passivo Circulante",
        passivoNaoCirculante:"Passivo Não Circulante",
        exigivelALongoPrazo:"Exigível a Longo Prazo",
        resultadoDeExerciciosFuturos:"Resultado de Exercícios Futuros",
        futuros:"Futuros",
        patrimonioLiquido:"Patrimônio Líquido",
        passivoTotal:"Passivo Total",
        capitalSocial:"Capital Social",
        receita:"Receita",
        receitaOperacionalLiquida:"Receita Operacional Líquida",
        receitaOperacionalBruta:"Receita Operacional Bruta",
        mediaFinanceira:"Média Financeira",
        solvenciaGeral:"Solvência Geral",
        liquidezCorrente:"Liquidez Corrente",
        produtividade:"Produtividade",
        liquidezGeral:"Liquidez Geral",
        endividamento:"Endividamento",
        imobilizacaoCapitalProprio:"Imobilização Capital Próprio",
        capitalizacao:"Capitalização",
        dataDoBalanco:"Data do Balanço",
        anoBalanco:"Ano do Balanço 1",
        anoBalanco2:"Ano do Balanço 2",
        balanco:"Balanço",
        balanco1:"Balanço 01",
        balanco2:"Balanço 02",
        termoConcordanciaVeracidade:"Termo de Concordância e Veracidade (SEI)",
        comprovanteResidencia:"Comprovante de Residência",
        procuracao:"Procuração",
        declaracaoEmpregador:"Declaração do Empregador",
        declaracaoSuperveniencia:"Declaração de Superveniência",
        declaracaoEnquadramento:"Declaração de Enquadramento/ Desenquadramento",
        secretaria: "Secretaria",
        unidade: "Unidade",
        naoCadastrado: "Não Cadastrado",
        contratoSocial: "Contrato Social",
        anexoFiplan: "Anexo Fiplan",
        finalidadeEmpresa: "Finalidade",
        dataValidadeDoBalanco: "Data de Validade do Balanço",
        documentoIdentificacao: "Documento de Identificação",
        periodo: "Período",
        orgaoUnidade: "Órgão/Unidade",
        objeto: "Objeto",
        acessar: "Acessar",
        numeroInscricao: "Número de Inscrição",
        documentosValidosIdentificacao: "RG, Passaporte ou Registro profissional no órgão de classe, CNH",
        unidadeSolicitante: "Unidade Solicitante",
        procuracaoEstrangeiro: "Procuração com Tradução Juramentada",
        socioServidor: "Sócio Servidor",
        relatorioInscricaoRegistroCadastral: "Relatório de Inscrição e Registro Cadastral do Fornecedor",
        numeroSolicitacao: "Nº Solicitação",
        localidades: "Localidades",
        atualizacaoCertidao: "Atualização de Certidão",
        solicitacoesVencidas: "Solicitações Prazo Validação Vencido",
        tipoCertificado:"Tipo de Cadastro",
        numeroProcessoSEI: "Número Processo SEI",
        dataAberturaEmpresa: "Data de Abertura da Empresa"
    },
    titulo:{
        cadastrarComoFornecedor:"Preencha os campos para se cadastrar como fornecedor.",
        statusDoCadastro:"O status da situação no CAF é",
        statusDoCadastroExtrato:"A Situação no CAF é",
        statusSituacaoSolicitacao:"A situação da solicitação no CAF é",
        pendenteDeAprovacao:"Pendente de aprovação",
        pendenteDeEnvio:"Pendente de envio",
        seuNumeroDeSolitacao:"Seu número de solicitação é ",
    },
    messages:{
        cadastro:{
            erroFamilia: "Essa família já foi adicionada.",
            sucesso:"Cadastro realizado com sucesso.",
            rejeitadoComSucesso: "Rejeitado com sucesso.",
            aprovadoComSucesso: "Aprovado com sucesso.",
            analistaAssociado:"Analista associado com sucesso.",
            alterado:"Alteração realizada com sucesso.",
            cadastroDocumentoSucesso:"Documento cadastrado com sucesso",
        },
        alertas: {
            contratoSocialAlterado: "Lembre-se: A alteração do Contrato Social exige atualização do Cartão CNPJ na aba “Regularidade Fiscal” e reanálise das famílias após o envio desta solicitação",
          },
        app:{
            sessaoExpiradaPorInatividade: "Sessão Expirada por inatividade."
        },
        dupla:{
            sucesso: "Registro salvo com sucesso."
        },
        validacao:{
            campoObrigatorio:"Este campo é obrigatório.",
            familiaJaAssociada:"Família já associada.",
            cpfCnpjVazio: "CPF ou CNPJ não pode ser vazio.",
            emailInValido:"Email  Inválido.",
            emailVazio:"Email  não pode ser vazio.",
            cpfInValido:"CPF  Inválido.",
            cpfVazio:"CPF não pode ser vazio.",
            cnpjVazio:"CNPJ não pode ser vazio.",
            cnpjInValido:"CNPJ  Inválido.",
            alphaNumeric:"A senha deve ter letras e números e 6 a 8 caracteres.",
            alphaNumericCaracter:"A senha deve conter pelo menos uma letra ou um caracter especial e números, com o quantitativo de 6 a 8 caracteres.",
            telefoneInValido:"Telefone  Inválido.",
            celularInValido:"Celular inválido.",
            faxInValido:"Fax inválido.",
            telefoneAdicionalInvalido:"Telefone Adicional Inválido.",
            cepInValido:"CEP inválido.",
            rgInValido:"RG inválido.",
            cpfCnpjInValido:"CPF ou CNPJ inválido.",
            cpfCnpjJaCadastrado:"CPF/CNPJ já cadastrado",
            percentualZero:"Percentual deve ser maior que 0",
            percentualMaiorQue100:"Empresa com quadro societário completo",
            percentualMenorQue100:"O percentual dos sócios deve somar 100%.",
            senhasDiferentes:"As senhas digitadas não coincidem.",
            emailsDiferentes: "E-mails digitados não coincidem.", // Nova mensagem adicionada
            celularInvalido: "O número de celular deve estar no formato internacional e conter entre 10 e 15 dígitos.", // Mensagem de erro para celular
            familiaVazia:"Cadastre pelo menos 1 família",
            familiaSemSalvar:"Clique no botão Adicionar para incluir a família desejada",
            usuarioSemPermissao: "Usuário não tem perfil de acesso ao sistema!",
            aproveOuRejeiteEsseCampo: "Aprove ou rejeite esse campo.",
            motivoIndeferimento: "Motivo de Indeferimento não pode ser vazio.",
            documentoInvalido: "Anexe um documento válido",
            situacaoFornecedorSuspenso: "Fornecedor com a situação 05 - Suspenso indeterminado, não permite atualização.",
            codigoCredorInvalido: "Código do credor inválido."
        },
        erro:{
            filtrosVazios: "Preencha pelo menos um filtro de pesquisa.",
            periodoInvalido: "Periodo inválido.",
            camposObrigatorios: "Preencha os 3 campos obrigatórios",
        }
    },

    "dataIterator": {
        "rowsPerPageText": "Items por pagina:",
        "rowsPerPageAll": "Todos",
        "pageText": "{0}-{1} de {2}",
        "noResultsText": "Nenhum item encontrado.",
        "nextPage": "Próxima página",
        "prevPage": "Página anterior"
      },
      "dataTable": {
        "rowsPerPageText": "Linhas por página:"
      },
      "noDataText": "Nenhum item encontrado."


}


